module.exports = __webpack_public_path__ + "img/composition-cards-animation.87e33e54.gif";